import { render } from "./VirtualPrintActionManager.vue?vue&type=template&id=2dbf1901&scoped=true"
import script from "./VirtualPrintActionManager.vue?vue&type=script&lang=js"
export * from "./VirtualPrintActionManager.vue?vue&type=script&lang=js"

import "./VirtualPrintActionManager.vue?vue&type=style&index=0&id=2dbf1901&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbf1901"]])

export default __exports__